
$.fn.hasExtension = function (exts) {
  return (new RegExp(`(${exts.join('|').replace(/\./g, '\\.')})$`)).test($(this).val());
};
